import { EventType } from '@/analytics/types';
import MembershipSelection from '@/app/[locale]/product/_steps/enums/MembershipSelection';
import WarrantySelection from '@/app/[locale]/product/_steps/enums/WarrantySelection';

export interface BundleAnalyticsProps {
  bundleEnabled: boolean | undefined;
  cart_id: string | null;
  membershipObj: {
    membershipSelection: MembershipSelection | undefined;
    product_id: number | undefined;
    sku: string;
  };
  warrantyObj: {
    product_id: number | null;
    sku: string | null;
    warrantySelection: WarrantySelection | undefined;
  };
}

const sendBundleAnalytics = async ({
  bundleEnabled,
  cart_id,
  membershipObj,
  warrantyObj,
}: BundleAnalyticsProps) => {
  // TODO: GROW-1620 Productize Bundle
  if (!bundleEnabled) return;

  const bundleModalSkipAnalytics = async (): Promise<void> => {
    await window.ouraAnalytics.track(EventType.CTAClicked, {
      action: 'cart',
      cta: 'skip_this_step',
      location: 'add_on_module',
      path: '/cart',
    });
  };

  const bundleModalAddToCartAnalytics = async (): Promise<void> => {
    await window.ouraAnalytics.track(EventType.CTAClicked, {
      action: 'cart',
      cta: 'add_to_cart',
      location: 'add_on_module',
      path: '/cart',
    });
  };

  const bundleModalMembershipAnalytics = async (): Promise<void> => {
    await window.ouraAnalytics.track(EventType.ProductAdded, {
      cart_id,
      category: 'membership',
      name: `${membershipObj.membershipSelection}`,
      product_id: membershipObj.product_id,
      sku: membershipObj.sku,
      variant_name: `one-year`,
    });
  };

  const bundleModalWarrantyAnalytics = async (): Promise<void> => {
    await window.ouraAnalytics.track(EventType.ProductAdded, {
      cart_id,
      category: 'extended_warranty',
      name: `${warrantyObj.warrantySelection}-extended-warranty`,
      product_id: warrantyObj.product_id,
      sku: warrantyObj.sku,
      variant_name: `${warrantyObj.warrantySelection}`,
    });
  };

  if (
    warrantyObj.warrantySelection === WarrantySelection.OneYear &&
    membershipObj.membershipSelection === MembershipSelection.OneMonth
  ) {
    await bundleModalSkipAnalytics();
  } else if (
    warrantyObj.warrantySelection !== WarrantySelection.OneYear &&
    membershipObj.membershipSelection !== MembershipSelection.OneMonth
  ) {
    await bundleModalAddToCartAnalytics();
    await bundleModalMembershipAnalytics();
    await bundleModalWarrantyAnalytics();
  } else if (warrantyObj.warrantySelection !== WarrantySelection.OneYear) {
    await bundleModalAddToCartAnalytics();
    await bundleModalWarrantyAnalytics();
  } else if (
    membershipObj.membershipSelection !== MembershipSelection.OneMonth
  ) {
    await bundleModalAddToCartAnalytics();
    await bundleModalMembershipAnalytics();
  }
};
export default sendBundleAnalytics;
